<template>
    <div class="course__edit_modules">
        <template v-if="courseModules.length">
            <div class="course__edit_modules_collapseaction">
                <div class="columns is-variable">
                    <div class="column">
                        <component-button
                            :name="'course-edit-modules-expandall'"
                            :icon="true"
                            :icon-name="openedAllGroup ? 'chevron-down' : 'chevron-right'"
                            :theme="'default'"
                            :text="true"
                            :size="'tiny'"
                            @click="switchAllGroups"
                        >{{ openedAllGroup ? 'Close' : 'Open' }} all groups
                        </component-button>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="isAddMode">
            <pop-notify
                ref="savedraftcoursenotify"
                :title-text="''"
                :content-text="'Before you add modules please save this course as a draft.'"
                :cancel-button-active="true"
                :cancel-button-text="'Go back'"
                :submit-button-text="'Save draft'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-name="'save-draft-course'"
                :prevent-close="true"
                @emit-close="redirectToDetails"
                @emit-submit="performSubmitValidate"
            ></pop-notify>
        </template>
        <template v-else-if="isEditMode || isShowMode">
            <component-note v-if="isRouteCatalogItem">
                <template v-if="user.hasAnyCustomerService(['CCS']) && user.isCourseCreator()">
                    <template v-if="courseOwnerCustomerId === user.customerId">You are currently editing the catalogue information only. To edit the source course please go to the <component-button
                        :name="'course-edit-modules-view-course'"
                        :theme="'default'"
                        :underline="true"
                        :size="'small'"
                        :text="true"
                        :to="{ name: 'ebs-course-edit-modules', params: { id: courseId }, query: { refresh: true } }"
                    >Course Creator view
                    </component-button>
                    </template>
                    <template v-else>No ability to edit modules of the course from other customer</template>
                </template>
                <template v-else>
                    You are currently editing the course catalogue information only. Course content can only be edited by the Course Creator
                </template>
            </component-note>
            <form-modulesform
                ref="courseformmodules"
                :disabled="isShowMode || isAddMode || requestPending || isRouteCatalogItem"
                :key="rerenderIndex"
                :modules="courseModules"
                @emit-add="performAddModule"
                @emit-remove="performRemoveModule"
                @emit-move="performMoveModule"
            ></form-modulesform>
            <div class="course__edit_modules_completeactions">
                <form-radio-horizontal
                    v-if="false"
                    :disabled="isShowMode"
                    :name="'course-edit-modules-complete'"
                    :label="'Complete modules'"
                    :items="[
                    {
                        name: 'In order',
                        value: 'in-order'
                    },
                    {
                        name: 'Any order',
                        value: 'any-order'
                    }
                ]"
                ></form-radio-horizontal>
            </div>
        </template>
        <template v-else>
            <template v-if="courseModules.length">
                <div class="course__edit_modules_collapseaction">
                    <div class="columns is-variable">
                        <div class="column">
                            <component-button
                                v-if="false"
                                :name="'course-edit-modules-expandall'"
                                :icon="true"
                                :icon-name="openedAllGroup ? 'chevron-down' : 'chevron-right'"
                                :theme="'default'"
                                :text="true"
                                :size="'tiny'"
                                @click="switchAllGroups"
                            >{{ openedAllGroup ? 'Close' : 'Open' }} all groups
                            </component-button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <component-note>No modules added to this course yet.</component-note>
            </template>
        </template>
    </div>
</template>

<script>
import { validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit } from '@/helpers/mixins'
import FormModulesform from '@/components/default/forms/FormModulesform'
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormRadioHorizontal from '@/components/default/forms/FormRadioHorizontal'
import ComponentNote from '@/components/default/shared/ComponentNote'
import { User } from '@/User'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'course-edit-modules',
  components: { PopNotify, ComponentNote, FormRadioHorizontal, ComponentButton, FormModulesform },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  data () {
    return {
      openedAllGroup: true,
      rerenderIndex: 0,
      requestPending: false,
      user: new User()
    }
  },
  computed: {
    courseId: {
      get () {
        return this.$store.getters.getEbsCourseId
      }
    },
    rootItemName () {
      return 'course'
    },
    nameActionCreate () {
      return 'ebsCourseCreate'
    },
    paramsActionCreate () {
      return { preventRedirect: true }
    },
    courseModules () {
      const modules = this.$store.getters.getEbsCourseModules
      return this.isRouteCatalogItem ? (modules.length ? modules[0].nodes : modules) : modules
    },
    courseSequence () {
      return this.$store.getters.getEbsCourseSequence
    },
    courseOwnerCustomerId () {
      return this.$store.getters.getEbsCourseOwnerCustomerId
    },
    //
    isAddMode () {
      return this.$route.name.includes('-add')
    },
    isEditMode () {
      return this.$route.name.includes('-edit')
    },
    isShowMode () {
      return this.$route.name.includes('-show')
    },
    isRouteCatalogItem () {
      return this.$route.name.includes('ebs-catalog-item-edit')
    }
  },
  watch: {
    courseSequence () {
      this.rerenderIndex++
    },
    rerenderIndex () {
      this.openedAllGroup = true
    }
  },
  methods: {
    performSubmitValidateThenCallback (response) {
      const courseId = response.id
      this.$router.push({ name: 'ebs-course-edit-modules', params: { id: courseId } })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-save-draft-course')
    },
    redirectToDetails () {
      this.$router.push({ name: 'ebs-course-add-details' })
    },
    switchAllGroups () {
      this.openedAllGroup = !this.openedAllGroup
      this.$eventBus.$emit(`emit-${this.openedAllGroup ? 'open' : 'close'}-all-groups`)
    },
    performAddModule (data) {
      this.rerenderIndex++
      this.requestPending = true
      this.$store.dispatch('ebsCourseAddModule', data).finally(() => {
        this.requestPending = false
      })
    },
    performRemoveModule (data) {
      this.rerenderIndex++
      this.requestPending = true
      this.$store.dispatch('ebsCourseRemoveModule', data).finally(() => {
        this.requestPending = false
      })
    },
    performMoveModule (data) {
      if (data.type === 'group' && data.to.length > 3) {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Module move',
          message: `You can't nest a group module deeper than at level 3.`,
          status: 'error'
        })
      } else {
        this.requestPending = true
        this.$store.dispatch('ebsCourseMoveModule', data).finally(() => {
          this.requestPending = false
        })
      }
      this.rerenderIndex++
    },
    openSaveDraftCourseNotify () {
      this.$refs.savedraftcoursenotify.openNotify()
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    if (this.isAddMode) {
      this.openSaveDraftCourseNotify()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditmodules";
</style>
